/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ProcessTypeEnum {
    Outgoing = 10,
    Incoming = 20,
}
